<template>
  <v-container fluid :style="noPadding === 'true' ? 'padding: 0;' : 'padding: 8px 12px;'">
    <v-layout :style="'max-height: ' + maxHeight + ';'">
      <v-flex :style="'overflow-y: auto; padding: 1px;' + (border === 'true' ? ' border: 1px solid #DDDDDD; border-radius: 3px;' : '')">
        <slot/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Scrollable',
  props: ['noPadding', 'deltaHeight', 'border'],
  computed: {
    maxHeight: function () {
      return 'calc(100vh - ' + (this.deltaHeight ? this.deltaHeight : '95') + 'px)'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Scrollable.vue